import type { EditRequestFormData } from "@nlc/shared-types";
import type { UseFormReturn } from "react-hook-form";

import { zodResolver } from "@hookform/resolvers/zod";
import { editRequestFormSchema } from "@nlc/shared-types";
import { useForm, useFormContext } from "react-hook-form";

export function useEditRequestForm(): UseFormReturn<EditRequestFormData> {
  const form = useForm<EditRequestFormData>({
    defaultValues: {
      assets: [],
      assignee: { designation: "", id: 0, name: "" },
      brandId: null,
      briefText: "",
      collaboratorIds: [],
      complexityId: null,
      creativeDirection: undefined,
      description: "",
      designerId: -1,
      designTypeId: null,
      dueDate: null,
      fileTypes: "",
      inspirations: [],
      internalDueDate: null,
      internalNotes: "",
      lengthOrPlatform: "",
      linkedRequestIds: [],
      magicalBriefCreator: {
        additionalGuidelines: "",
        brandGuidelines: "",
        creativeGoals: "",
        keyMessageAndCta: "",
        scope: "",
        script: "",
      },
      musicGenre: "",
      name: "",
      preferredDesignerIds: [],
      preferredFileType: "",
      restrictAiAssets: false,
      sizesNeeded: "",
      statusId: null,
      styleOfVideo: "",
      textForDesign: "",
    },
    mode: "onChange",
    resolver: zodResolver(editRequestFormSchema),
  });

  return {
    ...form,
  };
}

export function useEditRequestFormContext() {
  return useFormContext<EditRequestFormData>();
}
